import CompanyLogs from './CompanyLogs';
export default CompanyLogs;
